<template>
  <div class="opera-orderFromReport">

    <topNav :title="$t('orderFromReport_title')"></topNav>
    <datepik @change='getDate' ref="datepik" limit="pre" step="1"></datepik>

    <div class="ssearch" v-show="report != null && report.length > 0">
      <div style="float:left">
        <switch3 checked='swith' size="small" @change="switchChange"
                 :title1="$t('orderFromReport_switchbtn_title')"
                 :title2="$t('orderFromReport_switchbtn_title2')"
                 :title3="$t('book_src')"></switch3>
      </div>
      <div class="right">
        {{$t('memberSingleContrast_quota')}}
        <select v-model="zb" @change="drawChart" class="options">
          <option v-for="(item,key) in zbList" :value="key" :key="key">{{item}}</option>
        </select>
      </div>
    </div>
    <div id="chart" v-show="report != null && report.length > 0">

    </div>
    <div class="formTop" :class='{formTopFix:formPosition==true}'>
      <div class="topOne" style='text-align: left;width:28%'><span
        class="firstTh">{{$t('cashierReport_project')}}</span></div>
      <div class="topOne"><span>{{$t('orderFromReport_rent')}}</span></div>
      <div class="topOne"><span>{{$t('orderFromReport_rm_avg')}}</span></div>
      <div class="topOne"><span>{{$t('orderFromReport_rm_occ')}}</span></div>
      <div class="topOne"><span>{{$t('orderFromReport_total_charge')}}</span></div>
    </div>
    <div class="chartform" v-show="report != null && report.length > 0">
      <table style="width: 100%;table-layout: fixed; " class="tbodyH">
        <tr>
          <th style="width:28%"></th>
          <th style="width:18%"></th>
          <th style="width:18%"></th>
          <th style="width:18%"></th>
          <th style="width:18%"></th>
        </tr>
        <tr v-for='item in report' :key="item.code">
          <td class="title">{{item.descript}}</td>
          <td class="smallWith">{{item.rm_sold}}</td>
          <td>{{item.avg1}}</td>
          <td>{{item.occ}}</td>
          <td>{{item.rev_rm | toThousands}}</td>
        </tr>
        <tr style="width:100%;height:0.8rem;"></tr>
      </table>
    </div>

    <nothing :condition="report != null && report.length == 0"></nothing>
  </div>
</template>
<script>
  import datepik from "../operaCommon/datepik";
  import moment from 'moment'
  import nothing from '../operaCommon/nothing'
  import {Toast} from 'mint-ui'
  import switch3 from '../operaCommon/switch3'
  import _ from 'lodash'
  import echarts from 'echarts'

  export default {
    data() {
      return {
        seachOption: {
          code: '',//酒店范围代码（空时取当前）
          d: null,//日期（空时当前营业日）
          level: '',//酒店范围代码（可空）
          name: '',//i酒店范围的名称
          type: 'MARKET'
        },
        hotelName: '',
        swith: false,
        report: {},
        zb: 'rm_sold',
        zbList: {rm_sold: this.$t("orderFromReport_rent"), avg1: this.$t("orderFromReport_rm_avg"), occ: this.$t("orderFromReport_rm_occ"), rev_rm: this.$t("orderFromReport_rev_rm")},
        formPosition: false,//默认tab不固定
      }
    },
    mounted() {
      this.getData();
      //监听该页面滚动条
      document.getElementsByClassName('opera-orderFromReport')[0].addEventListener('scroll', this.boxScroll)
    },
    methods: {
      //滚动条上拉下滑顶部固定事件
      boxScroll() {
        var pxScoll = document.getElementsByClassName('opera-orderFromReport')[0].scrollTop;
        this.scrollTop = pxScoll / 37.5;
        var tbodyHeight = document.getElementsByClassName('tbodyH')[0].clientHeight / 37.5;
        var viewTbodyHeight = document.getElementsByClassName('opera-orderFromReport')[0].clientHeight / 37.5;
        //   console.log(this.scrollTop);
        //判断实际表格内容是否比表格直观视图大一些
        if (tbodyHeight > viewTbodyHeight - 1) {
          if (this.scrollTop > 9.4) {
            this.formPosition = true
          } else {
            this.formPosition = false
          }
        } else {
          this.formPosition = false;
        }
      },
      //生命周期结束后自动执行销毁监听事件
      destroyed() {
        document.getElementsByClassName('opera-orderFromReport')[0].removeEventListener('scroll', this.boxScroll)
      },
      getData() {
        this.$http.post('/mobilepmsapi/opera/report/getReport5', this.seachOption).then(res => {
          if (res.data.result == 0) {
            this.report = res.data.retVal.data;
            this.seachOption.d = moment(res.data.retVal.search.d).format('YYYY-MM-DD');
            this.$refs.datepik.setDate(moment(res.data.retVal.search.d).toDate());
            this.hotelName = res.data.retVal.name;
            this.drawChart();
          } else {
            Toast({
              message: res.data.msg,
              position: 'bottom',
              duration: 3000
            });
          }
        })
      },
      switchChange(value) {
        this.seachOption.type = value == 1 ? 'MARKET' : (value == 2 ? 'CHANNEL' : 'SOURCE');
        this.getData();
      },
      drawChart() {

        var echartFs = lib.flexible.rem2px([0.3])
        document.getElementById("chart").style.width = window.innerWidth + 'px';
        var myChart = echarts.init(document.getElementById('chart'), 'customed');
        // 绘制图表

        var data = [];

        for (var i = 0; i < this.report.length; i++) {
          var d = this.report[i];
          if (this.zb == "occ") {
            data.push({value: parseFloat(d[this.zb]), name: d.descript + ":" + d[this.zb]});
          } else {
            data.push({value: d[this.zb], name: d.descript + ":" + d[this.zb]});
          }
        }
        var option = {
          // color:['#e7737e','#8a98b5','#03c9cc','#ba9fe2','#2fb3f4','#ffb576'],
          series: [
            {
              name: this.$t("orderFromReport_chart_series_name"),
              type: 'pie',
              radius: '50%',
              center: ['50%', '50%'],
              roseType: 'angle',
              data: data,
              itemStyle: {
                normal: {
                  label: {
                    textStyle: {
                      fontSize: echartFs
                    }
                  }
                },
              }
            }
          ]
        };
        myChart.setOption(option);

      },
      getDate(time) {
        this.seachOption.d = time;
        // console.log(time)
        this.getData()
      },
      getHotel(hotel) {
        this.seachOption.code = hotel.code;
        this.seachOption.level = hotel.level;
        this.seachOption.name = hotel.descript;
        // console.log(hotel.code)
        this.getData()
      },
    },
    filters: {
      toThousands(num) {
        return ("" + num).replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, "$1,");
      }
    },
    components: {
      datepik,
      nothing,
      switch3
    }
  }
</script>
<style lang='less'>
  .opera-orderFromReport {
    background-color: #F6F8F9;
    height: 100vh;
    min-height: 100%;
    overflow: auto;

    .formTop {
      width: 100%;
      float: left;

      .topOne {
        width: 18%;
        height: 1.0133rem;
        color: #fff;
        background-color: #f69c2d;
        display: inline-block;
        text-align: right;
        line-height: 1.0133rem;
        float: left;
        font-weight: bold;
      }

      span {
        padding-right: 0.2rem;
      }

      .firstTh {
        padding-left: 0.2rem;
      }
    }

    .formTopFix {
      position: fixed;
      top: 1.04rem;
      z-index: 200;
    }

    .ssearch {
      width: 96%;
      margin: 0.2667rem auto;

      .right {
        float: right;
        height: 0.9333rem;
        line-height: 0.9333rem;
      }
    }

    #chart {
      width: 10rem;
      margin: 0 auto;
      height: 10rem;
      box-sizing: border-box;
    }

    .chartform {
      width: 100%;
      margin: 0 auto;

      table {
        width: 100%;

        th {
          // height: 38px;
          color: #fff;
          background-color: #F69C2D;
          width: 20%;
        }

        .title {
          text-align: left;
          padding-left: 0.2rem;
        }

        td {
          text-align: right;
          word-wrap: break-word;
          width: 33.3%;
          padding: 14px 0.2rem 14px 0;

          .icon-shangsheng {
            position: relative;
            left: -0.2667rem;
            line-height: 1.0933rem;
            color: #FF485F;
          }

          .icon-xiajiang {
            position: relative;
            left: -0.2667rem;
            line-height: 1.0933rem;
            color: #249F17;
          }
        }

        .smallWith {
          width: 27%;
        }
      }
    }

    .flip-list-enter {
      background-color: red;
    }
  }

  .options {
    box-sizing: border-box;
    width: 93.75px;
    height: 0.64rem;
    border: 1px solid #ccc;
    text-align: left;
    padding-left: 0.1333rem;
    line-height: 0.64rem;
    outline: none;
  }
</style>



// WEBPACK FOOTER //
// orderFromReport.vue?36fa60c6